import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import { useIntl } from "react-intl";

const UpdateLoginComponent = ({ classes, open, handleClose, handleUpdateLogin, login, handleSetLogin }) => {
  const intl = useIntl();

  const handleCloseModal = () => {
    handleSetLogin("");
    handleClose();
  };

  const handleSubmit = () => {
    handleUpdateLogin(login);
  };

  return (
    <Dialog open={open} onClose={handleCloseModal} fullWidth maxWidth={"sm"}>
      <DialogTitle id="form-dialog-title">{intl.formatMessage({ id: "custom.user.update_login" })}</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <TextField
          label={intl.formatMessage({ id: "custom.user.new_login" })}
          value={login}
          variant="outlined"
          onChange={(e) => handleSetLogin(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button className={classes.button} onClick={handleCloseModal}>
          {intl.formatMessage({ id: "ra.action.cancel" })}
        </Button>
        <Button className={classes.button} disabled={!login} onClick={handleSubmit}>
          {intl.formatMessage({ id: "ra.action.send" })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateLoginComponent;
